import { Component, OnInit } from '@angular/core';
import { Pwa } from '@freelancer/pwa';
import { ModalService } from '../modal/modal.service';

@Component({
  selector: 'fl-update-native-alert',
  template: ``,
})
export class UpdateNativeAlertComponent implements OnInit {
  constructor(private pwa: Pwa, private modalService: ModalService) {}

  async ngOnInit() {
    if (
      this.pwa.isNative() &&
      // FIXME: due to some incompatibility issues, version checks sometimes don't work
      // eslint-disable-next-line deprecation/deprecation
      this.pwa.isCapacitor2()
    ) {
      this.modalService.open('UpdateNativeModal', {
        closeable: false,
      });
    }
  }
}
